module.exports = __webpack_public_path__ + "img/Alien_symbol_9.efbf6bcb.png";